//守护区域类型(危险1， 安全2)
export enum GuardType {
  dangerous = 1,
  safe = 2,
}

export const guardTypeName = {
  [GuardType.dangerous]: '危险区域',
  [GuardType.safe]: '安全区域',
};

export const guardTypes = [
  {
    key: GuardType.safe,
    value: guardTypeName[GuardType.safe],
  },
  {
    key: GuardType.dangerous,
    value: guardTypeName[GuardType.dangerous],
  },
];

//守护区域形状类型
export enum ShapeType {
  circle = 1, //圆形
  polygon = 2, //多边形
}


